import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimaryHover, grayIconFill } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	selectTrigger: {
		minWidth: 112,
		height: 40,
	},
	contactDropdownItem: {
		':hover': {
			background: 'rgba(232, 243, 249, 0.5)',
		},
	},
	contactDropdownItemHighlighted: {
		background: 'rgba(232, 243, 249, 0.5)',
	},
	andMore: {
		alignItems: 'center',
		color: grayIconFill,
		display: 'flex',
		fontSize: 14,
		fontStyle: 'italic',
		height: 32,
		paddingLeft: 50,
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			'span'
		),
	},
	autocompleteContainer: {
		background: 'white',
		border: `1px solid ${borderColor}`,
		borderRadius: 3,
		marginLeft: 1,
		marginTop: 1,
		maxWidth: 640,
		padding: '20px 0',
		width: '50vw',
	},
	container: {},
	highlight: {
		background: 'rgba(232, 243, 249, 0.5)',
	},
	inputAnchor: {
		maxWidth: 640,
	},
	searchInput: {
		height: 40,
		minWidth: 282,
		maxWidth: 640,
	},
	recentSearch: {
		width: '100%',
	},
	searchButton: {
		':has(*) > svg': {
			width: 20,
			height: 20,
		},
	},
	title: {
		':first-of-type': {
			marginTop: 0,
		},
		color: brandPrimaryHover,
		fontSize: 12,
		letterSpacing: 1.3,
		margin: '8px 30px',
		textTransform: 'uppercase',
	},
});
